module.exports = __webpack_public_path__ + "img/bgt01.3bc6b348.png";